import { Button, IconButton, styled } from "@material-ui/core";
import { motion } from "framer-motion";
import LocalizedLink from "../../components/localized-link";

export const OutsideList = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  position: "relative",
  width: "100%",
  overflowX: "auto",
  "-webkit-overflow-scrolling": "touch",
  // maxWidth: "100vw",
  "@media (hover: hover)": {
    overflowX: "hidden"
  },
  [theme.breakpoints.only("xs")]: {
    width: "calc(100% + 32px)",
    marginLeft: "-16px",
    marginRight: "-16px",
    paddingLeft: "16px"
  },
  [theme.breakpoints.only("sm")]: {
    width: "calc(100% + 48px)",
    marginLeft: "-24px",
    marginRight: "-24px",
    paddingLeft: "24px"
  },
  [theme.breakpoints.up("md")]: {
    width: "calc(100% + 128px)",
    marginLeft: "-64px",
    marginRight: "-64px",
    paddingLeft: "64px"
  },
  [theme.breakpoints.up("xl")]: {
    width: "100%",
    marginLeft: "0px",
    marginRight: "0px",
    paddingLeft: "0px"
  }
}));

export const InnerList = styled(motion.div)(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  alignItems: "flex-start",
  flexWrap: "nowrap",
  [theme.breakpoints.between("xs", "sm")]: {
    paddingRight: "24px"
  },
  [theme.breakpoints.up("md")]: {
    paddingRight: "64px"
  }
}));

export const SellAllButton = styled(LocalizedLink)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  backgroundColor: theme.palette.grey[300],
  borderRadius: "24px",
  height: "36px",
  fontSize: "12px",
  fontFamily: "Roobert",
  lineHeight: 1,
  textTransform: "uppercase",
  fontWeight: 600,
  letterSpacing: "1px",
  padding: "4px 20px",
  "&:hover": {
    backgroundColor: theme.palette.grey[400]
  },
  [theme.breakpoints.down("xs")]: {
    borderRadius: "18px",
    height: "26px",
    fontSize: "10px"
  }
}));

export const ArrowButton = styled(IconButton)(({ theme }) => ({
  width: "36px",
  height: "36px",
  backgroundColor: theme.palette.grey[300],
  userSelect: "none",
  "& .MuiSvgIcon-root": {
    width: "16px",
    height: "16px"
  },
  "&:hover": {
    backgroundColor: theme.palette.grey[400]
  },
  "&.Mui-disabled": {
    backgroundColor: theme.palette.grey[300],
    color: theme.palette.grey[500]
  }
}));
